<template>
  <div class="modal fade" ref="rateModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t("property.ratesExpired") }}</h5>
        </div>
        <div class="modal-body">
          <p>
            {{ $t("property.ratesExpiredDescription") }}
          </p>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            @click="refreshRates"
            class="btn btn-primarys g-primary-button"
          >
            {{ $t("property.refreshRates") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
export default {
  name: "RateExpiringModal",
  data() {
    return {
      rateModal: null,
      ratesExpired: false,
      rateExpiryTimer: null,
    };
  },
  methods: {
    startRateExpiryTimer() {
      clearTimeout(this.rateExpiryTimer);
      this.rateExpiryTimer = setTimeout(() => {
        this.ratesExpired = true;
        this.showExpiryModal();
      }, 20 * 60 * 1000);
    },
    showExpiryModal() {
      if (!this.rateModal) {
        this.rateModal = new Modal(this.$refs.rateModal, {
          backdrop: "static",
          keyboard: false,
        });
      }
      this.rateModal.show();
    },
    refreshRates() {
      this.rateModal.hide();
      this.ratesExpired = false;
      this.$emit("refreshAvailability");
    },
  },
};
</script>
